import React from 'react';
import greenBullet from '../assets/images/green-bullet.svg';
import PenFoster from "../assets/images/portfolio/PennFoster.jpg"
import './PortfolioPage.css';

const PortfolioPage = () => {
  const portfolioCompanies = [
    {
      name: 'Penn Foster Group',
      logo: 'PennFoster.jpg',
      description: "Penn Foster Group is building a leading platform in the U.S. that is bridging the gap between education and employer opportunity to build tomorrow's workforce. Penn Foster partners with employers, education and workforce organizations, and local community groups to design and deliver digital and blended learning programs that attract, upskill, and retain workers in America's fastest-growing fields and professions.",
      year: '2021',
      status: 'Unrealized',
      sector: 'Business Services / Consumer',
      headquarters: 'Scranton, PA',
      visitSite: 'https://www.pennfoster.edu/'
    },
    {
      name: 'Mavis Tire Express Services',
      logo: 'MavisTireExpress.svg',
      description: "Mavis is one of the largest independent operators of tire and automotive service centers in the country with more than 1,100 service stores in New England, the Midwest, and the Southern U.S. Mavis offers quality tire and tire-related services, as well as a full range of automotive services and repairs to consumers and commercial customers.",
      year: '2021',
      status: 'Unrealized',
      sector: 'Specialty Industrials / Consumer',
      headquarters: 'Millwood, NY',
      visitSite: 'https://www.mavistire.com/'
    },
    {
      name: 'QualDerm Partners',
      logo: 'QualDerm.jpg',
      description: "QualDerm Partners is a leading dermatology management services organization in the U.S. providing comprehensive management services to over 100 clinics across 11 states. QualDerm is transforming the way skin care is delivered, ensuring the highest level of care while maintaining the unique culture of each practice, including general dermatology, surgical, cosmetic, and pathology services.",
      year: '2021',
      status: 'Unrealized',
      sector: 'Healthcare',
      headquarters: 'Brentwood, TN',
      visitSite: 'https://www.qualderm.com/'
    },
    {
      name: 'POLYWOOD',
      logo: 'Polywood.jpg',
      description: "POLYWOOD is one of the leading high-density polyethylene outdoor furniture manufacturers in the U.S. and a pioneer in the fast-growing segment of the high-quality outdoor furniture market, offering consumers a superior value product that is stylish, comfortable, durable, low maintenance, and one of the few vertically integrated HDPE furniture manufacturers in the world.",
      year: '2021',
      status: 'Unrealized',
      sector: 'Specialty Industrials / Consumer',
      headquarters: 'Syracuse, IN',
      visitSite: 'https://www.polywood.com/'
    },
    {
      name: 'Harbor',
      logo: 'Harbor.jpg',
      description: "Harbor is the partner of choice for law firms and corporate legal departments seeking to innovate, manage, and improve their operations through strategic advisory and transformation, technology and artificial intelligence, and vendor management to optimize the delivery of legal services across the entire corporate legal department.",
      year: '2022',
      status: 'Unrealized',
      sector: 'Business Services',
      headquarters: 'Chicago, IL',
      visitSite: 'https://harborcm.com/'
    },
    {
      name: 'CenExel',
      logo: 'GenExel.png',
      description: "CenExel is a leading, world-renowned network of research sites providing pharmaceutical and biotechnology companies with access to high-quality, diverse patients while accelerating and advancing life-changing therapies. CenExel operates a network of complex clinical trials, leveraging scientific expertise, which drives clinical investigation, optimized patient recruitment, and integrated study management.",
      year: '2022',
      status: 'Unrealized',
      sector: 'Healthcare',
      headquarters: 'Draper, UT',
      visitSite: 'https://cenexel.com/'
    }
  ];

  return (
    <div className="portfolio-page">
      <div className="portfolio-hero">
        <div className="container">
          <h1 className="portfolio-hero-title">Our companies are looking to tomorrow</h1>
          <p className="portfolio-hero-subtitle">
            We work collaboratively with company owners and management teams to improve overall performance by employing intelligent areas of digital transformation
          </p>
        </div>
      </div>

      <section className="portfolio-companies-section">
        <h2 className="section-label">
          <img src={greenBullet} alt="" className="bullet-image" />
          PORTFOLIO COMPANIES
        </h2>

        {portfolioCompanies.map((company, index) => (
          <div className="portfolio-company-item" key={index}>
            <div className="company-logo">
              <img src={require(`../assets/images/portfolio/${company.logo}`)} alt="" className="company-logo" />

            </div>
            <div className="company-content">
              <h3 className="company-name">{company.name}</h3>
              <p className="company-description">{company.description}</p>



              <a href={company.visitSite} target="_blank" rel="noopener noreferrer" className="visit-site-link">
                VISIT SITE
              </a>
            </div>
            <div className="company-details">
              <div className="detail-item">
                <span className="detail-label">YEAR</span>
                <span className="detail-value">{company.year}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">STATUS</span>
                <span className="detail-value">{company.status}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">SECTOR</span>
                <span className="detail-value">{company.sector}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">HEADQUARTERS</span>
                <span className="detail-value">{company.headquarters}</span>
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="contact-section">
        <div className="contact-grid">
          <div className="contact-item talk-with-us">
            <h3 className="contact-title">
              <img src={greenBullet} alt="" className="bullet-image" />
              TALK WITH US
            </h3>
            <p className="contact-description">
              We're always eager to make new connections and provide more information.
            </p>
            <a href="/contact" className="contact-link">
              GET IN TOUCH
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
              </svg>
            </a>
          </div>
          <div className="contact-item join-us">
            <h3 className="contact-title">
              <img src={greenBullet} alt="" className="bullet-image" />
              JOIN US
            </h3>
            <p className="contact-description">
              Join our dynamic and ambitious team.
            </p>
            <a href="mailto:Careers@BayPine.com" className="contact-link">
              INQUIRE ABOUT AVAILABLE OPPORTUNITIES
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PortfolioPage;
